export const STATIC_ASSET_URL = "https://cdn.zapier.com/zapier/";

/**
 * Make sure the URL is valid.
 *
 * We make sure to dedupe some URL parts:
 * - The provided `staticPath` is generally suffixed with a `/`.
 * - Some legacy components are still prefixing assets with `/static`.
 */
const sanitizeUrl = (url: string) =>
  url
    .replace(/(\/){2,}/g, "$1")
    .replace(/(https?:\/)/g, "$1/")
    .replace(/(\/static){2,}/g, "$1");

/**
 * Check if a given URL should remain unprefixed.
 */
const shouldRemainUnprefixed = (url = "") =>
  ["http", "data:", "/media/storage", "blob:"].some(
    beginning => (url || "").indexOf(beginning) === 0
  );

const buildStaticAssetUrl = (
  url: string,
  staticPath: string = STATIC_ASSET_URL
) => (shouldRemainUnprefixed(url) ? url : sanitizeUrl(`${staticPath}/${url}`));

export default buildStaticAssetUrl;
